module.exports = __webpack_public_path__ + "img/duanlu2.765ebe6b.svg";